import languages from '../../translations/index';

export const namespaced = true;

const supportedLanguages = Object.getOwnPropertyNames(languages);

export const state = {
  language: localStorage.getItem('language'),
};

export const mutations = {
  SET_LANGUAGE(state, lang) {
    localStorage.setItem('language', lang);
    state.language = lang;
  },
};

export const actions = {
  setLanguage({ commit }, languages) {
    if (typeof languages === 'string') {
      commit('SET_LANGUAGE', languages);
    } else {
      const language = supportedLanguages.find(sl => languages.find(l => (l.split(new RegExp(sl, 'gi')).length - 1 > 0 ? sl : null)));
      commit('SET_LANGUAGE', language);
    }
  },
};
